var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4271_33676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.625 44.5H93.375L56 21.5L18.625 44.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.125 44.5V73.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.375 44.5V73.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.625 44.5V73.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.875 44.5V73.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 73.25H90.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 84.75H96.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.6352,
    cy: 89.435,
    r: 23.3647,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 2.03171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4344 99.5945C92.4344 100.436 91.7522 101.118 90.9107 101.118C90.0691 101.118 89.3869 100.436 89.3869 99.5945V91.2409H81.0331C80.1915 91.2409 79.5093 90.5587 79.5093 89.7171C79.5093 88.8755 80.1915 88.1933 81.0331 88.1933H89.3869V79.8402C89.3869 78.9986 90.0691 78.3164 90.9107 78.3164C91.7522 78.3164 92.4344 78.9986 92.4344 79.8402V88.1933H100.787C101.629 88.1933 102.311 88.8755 102.311 89.7171C102.311 90.5587 101.629 91.2409 100.787 91.2409H92.4344V99.5945Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4271_33676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e0688ac197ae70c9594d7e4b2dba6329.svg";
export { ForwardRef as ReactComponent };